export default __webpack_public_path__ + "static/media/Maharaja04.e377faa1.jpg";